import { useEffect, useState } from 'react';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppModal } from 'shared/UI/UIKit/Modal';
import { AppText } from 'shared/UI/UIKit/Text';
import type { EducationClass } from 'services/api';
import { EducationClassesCheckboxGroups } from '../EducationClassesCheckboxGroups';

type ReplaceClassesModalProps = {
  visible: boolean;
  onCancel: () => void;
  onApply: (educationalClassIds: number[]) => void;
  educationClasses: EducationClass[];
  tableDisabled: boolean;
};

export const ReplaceClassesModal = ({
  visible,
  onCancel,
  onApply,
  educationClasses,
  tableDisabled,
}: ReplaceClassesModalProps) => {
  const [classIds, setClassIds] = useState<number[]>([]);

  useEffect(() => {
    if (visible) {
      setClassIds([]);
    }
  }, [visible]);

  const handleOk = () => {
    onApply(classIds);
  };

  const footer = (
    <AppFlex direction="row" unit="8">
      <AppButton type="primary" htmlType="button" disabled={tableDisabled} onClick={handleOk}>
        Применить
      </AppButton>
      <AppButton type="outline" htmlType="button" onClick={onCancel}>
        Отмена
      </AppButton>
    </AppFlex>
  );

  const content = (
    <AppFlex direction="column" unit="8">
      <AppText type="secondary" size={14}>
        Выбранные строки получат один и тот же набор классов
      </AppText>
      <EducationClassesCheckboxGroups
        educationClasses={educationClasses}
        value={classIds}
        disabled={tableDisabled}
        onChange={setClassIds}
      />
    </AppFlex>
  );

  return (
    <AppModal
      visible={visible}
      onCancel={onCancel}
      size="auto"
      title="Заменить классы"
      content={content}
      destroyOnClose
      footer={footer}
      maskClosable={false}
    />
  );
};
